import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups', {
        url: '/directory-groups',
        redirectTo,
        component: 'companyUserDirectoriesDirectoryGroups',
        resolve: {directories},
    });
}

async function redirectTo(transition) {
    const currentCompany = await transition.injector().getAsync('currentCompany');
    const isOrganizationAdmin = currentCompany.authoritiesConstants === 'ORGANIZATION_ADMIN';
    const directoryState = 'company.user-directories.directory-groups.directory';
    const allAccountsState = 'company.user-directories.directory-groups.all-accounts';
    return isOrganizationAdmin ? directoryState : allAccountsState;
}

/** @ngInject */
function directories(companyId, DirectoriesResource) {
    return DirectoriesResource.getCompanyDirectories(companyId)
        .then((directories) => [
            {
                id: 'saaspass-cloud-directory',
                type: 'saaspass-cloud-directory',
                name: 'SAASPASS Cloud Directory',
            },
            ...directories,
        ])
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/user-directories.state.js